var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',[_vm._v("\n  "+_vm._s(_vm.amount)+"\n  "),_c('span',[_vm._v("元")])])}
var staticRenderFns = []

export { render, staticRenderFns }